import type { MarketConfiguration } from "./const";
import {
  ContentfulEnum,
  CurrencyEnum,
  ElevateMarketEnum,
  LocaleEnum,
  MarketEnum,
  RegionEnum,
  ServiceLocaleEnum,
} from "./const";

const estonia: MarketConfiguration = {
  code: MarketEnum.ee,
  label: "Estonia",
  descriptiveLabel: "Estonian",
  contentfulLocale: ContentfulEnum.en,
  contentfulCountry: "Estonia",
  locale: LocaleEnum.ee,
  serviceLocale: ServiceLocaleEnum.ee,
  language: {
    code: "en",
    label: "English",
    flag: "gb",
  },
  currency: CurrencyEnum.eur,
  link: "https://www.no-ga.com/en-ee",
  termsSlug: "terms-online",
  loop54Market: MarketEnum.ee,
  adyenMarket: MarketEnum.ee,
  elevateMarket: ElevateMarketEnum.eu,
  freeShippingThreshold: 100,
  freeShippingEnabled: false,
  externalStoreId: "ecom-noga",
  searchPathName: "search",
  adyenCheckoutEnabled: true,
  walleyCheckoutEnabled: false,
  hasTrustPilot: false,
  region: RegionEnum.europe,
  norceImageCdn: ["local", "dev", "stage"].includes(
    process.env.NEXT_PUBLIC_ENVIRONMENT ?? "",
  )
    ? "https://media.stage.cdn-norce.tech/1413"
    : "https://cdn.no-ga.com",
};

export default estonia;
